export const preloadScript = (scripUrl) => {
  const script = document.createElement('link')
  script.href = scripUrl
  script.rel = 'preload'
  script.as = 'script'
  document.head.appendChild(script)
}

export const preloadTinyMCE = () => {
  preloadScript('https://d25510ev64x81w.cloudfront.net/js/tinymce/5.10.5/tinymce.min.js')
  preloadScript('https://d25510ev64x81w.cloudfront.net/js/tinymce/5.10.5/themes/silver/theme.min.js')
  preloadScript('https://d25510ev64x81w.cloudfront.net/js/tinymce/5.10.5/icons/default/icons.min.js')
}
